import { render } from "./MultiSelectInput.vue?vue&type=template&id=9d870444&scoped=true&ts=true"
import script from "./MultiSelectInput.vue?vue&type=script&lang=ts"
export * from "./MultiSelectInput.vue?vue&type=script&lang=ts"

import "./multiselect-input.scss?vue&type=style&index=0&id=9d870444&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d870444"]])

export default __exports__